/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var UIUtil = require('psa-core/util/ui');
var GridView = require('psa-marionette/views/GridView');

var ConfirmationModalView = require('common/views/ConfirmationModalView');
var MultiButtonCell = require('common/backgrid/MultiButtonCell');

var SubmitSecondaryName = require('../services/SubmitSecondaryName');

module.exports = GridView.extend({
  className: 'corp-fin-secondary-names-section-view',

  onBeforeRender: function() {
    if (GridView.prototype.onBeforeRender) {
      GridView.prototype.onBeforeRender.apply(this.arguments);
    }

    var isReadOnly = this.options.isReadOnly;
    var isRegistration = this.options.recordCategoryId === '1';

    var self = this;
    var isExemption = self.options.recordCategoryId === '2';
    this.options.columns = [
      {
        name: 'displayName',
        label: 'Secondary Name',
        cell: 'string',
        headerCell: 'custom',
        width: 30,
        editable: false
      },
      {
        name: 'titleDisplay',
        label: 'Title',
        cell: 'string',
        headerCell: 'custom',
        width: 30,
        editable: false
      },
      {
        name: 'typeDisplay',
        label: 'Corporation/Individual',
        cell: 'string',
        headerCell: 'custom',
        width: isRegistration === 'true' ? 30 : 0,
        editable: false
      },
      {
        name: 'editDeleteMultiButtonCell',
        label: '',
        width: 10,
        cell: MultiButtonCell.extend({
          buttons: [
            {
              name: '',
              labelClass: 'fa fa-edit',
              buttonClass: 'btn-primary btn-sm edit-secondary-name',
              href: function(model) {
                var isRegistration = self.options.recordCategoryId === '1';

                if (isRegistration) {
                  return (
                    '#corpfin/registration/' + model.get('recordId') + '/secondary-name/' + model.get('id') + '/edit'
                  );
                } else if (isExemption) {
                  return '#corpfin/exemption/' + model.get('recordId') + '/secondary-name/' + model.get('id') + '/edit';
                }
              },
              renderable: function() {
                return !isReadOnly;
              }
            },
            {
              name: '',
              labelClass: 'fa fa-trash',
              buttonClass: 'btn-danger btn-sm delete-secondary-name',
              onClick: this.onClickDeleteSecondaryName.bind(this),
              renderable: function() {
                return !isReadOnly;
              }
            }
          ]
        }),
        editable: false,
        sortable: false
      }
    ];
    this.options.emptyText = 'No Secondary Names';
    if (isExemption) {
      this.options.columns.splice(2, 1);
    }
  },

  onClickDeleteSecondaryName: function(e, model) {
    e.preventDefault();
    var self = this;
    var message = 'Are you sure you want to delete this secondary name?';
    UIUtil.showModal({
      title: 'Confirm Deleting Secondary Name',
      view: new ConfirmationModalView({
        confirmText: 'Delete Secondary Name',
        model: new Backbone.Model({
          message: message,
          onConfirm: function() {
            var secondaryNameId = model.get('id');
            return SubmitSecondaryName({ secondaryNameId: secondaryNameId, isDeleted: '1' });
          },
          onConfirmDone: function() {
            self.collection.remove(model);
          }
        })
      })
    });
  }
});
